/** 资源库三语文案分片 · 主页/页面级（由 strings.ts 聚合） */
export const resPartPage = {
  /** 访客态标题：一个空间管理所有素材 */
  resPageGuestTitle: {
    en: "One space to manage your videos, images, characters and shot-analysis materials",
    zh: "一个空间,管理你的视频、图片、数字人与拉片资料",
    id: "Satu ruang untuk mengelola video, gambar, karakter, dan materi analisis shot Anda",
  },
  /** 访客态描述：集中管理素材与产出 */
  resPageGuestDesc: {
    en: "Manage all uploaded materials and outputs in one place. Everything is organized by category for quick access, so creating is never interrupted by searching for assets.",
    zh: "集中管理所有上传的素材与产出内容。所有素材分类管理方便你随时调用,让创作不再被找素材打断。",
    id: "Kelola semua materi unggahan dan hasil produksi secara terpusat. Semua materi dikelola per kategori agar mudah diakses kapan saja, sehingga berkarya tidak lagi terganggu mencari materi.",
  },
  /** 访客态亮点：视频/图片/数字人统一管理 */
  resPageGuestHlUnified: {
    en: "Videos, images and characters managed together",
    zh: "视频、图片、数字人统一管理",
    id: "Video, gambar, dan karakter dikelola dalam satu tempat",
  },
  /** 访客态亮点：拉片库自动归档 */
  resPageGuestHlBreakdown: {
    en: "Shot-analysis library auto-archives; reopen storyboards and voiceover/narration anytime",
    zh: "拉片库自动归档,可重新打开分镜与口播/旁白",
    id: "Pustaka analisis shot terarsip otomatis; buka kembali storyboard serta sulih suara/narasi kapan saja",
  },
  /** 访客态亮点：随时使用爆款模版 */
  resPageGuestHlTemplates: {
    en: "Apply trending templates anytime while creating",
    zh: "在创作中方便你随时使用爆款模版",
    id: "Gunakan templat viral kapan saja saat berkarya",
  },
  /** 访客态预览角标：拆解报告 */
  resPagePreviewLabelReport: { en: "Breakdown report", zh: "拆解报告", id: "Laporan analisis" },
  /** AI 生图弹窗标题 */
  resPageAiGenTitle: { en: "AI Image Generation", zh: "AI 生图", id: "Gambar AI" },
  /** 删除文件夹确认框标题 */
  resPageDeleteFolderTitle: { en: "Delete Folder", zh: "删除文件夹", id: "Hapus Folder" },
  /** 删除文件夹确认框正文 */
  resPageDeleteFolderLead: { en: "Delete the selected folder?", zh: "确认删除所选文件夹吗？", id: "Hapus folder yang dipilih?" },
  /** 删除文件夹确认框提示 */
  resPageDeleteFolderHint: {
    en: "This also deletes all files in the folder. This cannot be undone.",
    zh: "此操作会同时删除该文件夹下所有文件，删除后不可恢复。",
    id: "Tindakan ini juga menghapus semua file di dalam folder dan tidak dapat dipulihkan.",
  },
  /** 删除数字人确认框标题 */
  resPageDeleteDigitalTitle: { en: "Delete Character", zh: "删除数字人", id: "Hapus Karakter" },
  /** 删除素材确认框标题 */
  resPageDeleteMaterialTitle: { en: "Delete Asset", zh: "删除素材", id: "Hapus Materi" },
  /** 删除数字人确认框正文（含衍生数量） */
  resPageDeleteDigitalLeadN: {
    en: "Delete character “{name}” and its {n} derived characters?",
    zh: "确认删除数字人「{name}」及其 {n} 个衍生形象吗？",
    id: "Hapus karakter “{name}” beserta {n} karakter turunannya?",
  },
  /** 删除数字人确认框正文（无衍生） */
  resPageDeleteDigitalLead: {
    en: "Delete character “{name}”?",
    zh: "确认删除数字人「{name}」吗？",
    id: "Hapus karakter “{name}”?",
  },
  /** 删除素材确认框正文 */
  resPageDeleteMaterialLead: { en: "Delete the selected asset?", zh: "确认删除所选素材吗？", id: "Hapus materi yang dipilih?" },
  /** 删除数字人提示：级联删除衍生后代 */
  resPageDeleteDigitalHintCascade: {
    en: "All derived descendants will be deleted too. Deletion fails if the character or any derivative/copy is referenced by a task.",
    zh: "将同时删除该数字人的全部衍生后代。若自身或任一衍生/副本已被任务引用，则无法删除。",
    id: "Semua turunan karakter ini akan ikut dihapus. Penghapusan gagal jika karakter atau salah satu turunan/salinannya sedang dirujuk oleh tugas.",
  },
  /** 删除数字人提示：无衍生 */
  resPageDeleteDigitalHint: {
    en: "Deletion fails if this character is referenced by a task. This cannot be undone.",
    zh: "若该数字人已被任务引用则无法删除。删除后不可恢复。",
    id: "Penghapusan gagal jika karakter ini sedang dirujuk oleh tugas. Setelah dihapus tidak dapat dipulihkan.",
  },
  /** 通用删除提示：不可恢复 */
  resPageDeleteHint: { en: "This cannot be undone.", zh: "删除后不可恢复。", id: "Tidak dapat dipulihkan setelah dihapus." },
  /** 批量删除确认框标题 */
  resPageDeleteSelectedTitle: { en: "Delete Selected Items", zh: "删除所选项目", id: "Hapus Item Terpilih" },
  /** 批量删除确认框正文（含数量） */
  resPageDeleteSelectedLead: {
    en: "Delete the {n} selected items?",
    zh: "确认删除所选 {n} 项吗？",
    id: "Hapus {n} item terpilih?",
  },
  /** 批量删除提示：含文件夹级联 */
  resPageBatchDeleteHintFolders: {
    en: "Folders in the selection are deleted together with all files inside. This cannot be undone.",
    zh: "其中的文件夹会同时删除其下所有文件，删除后不可恢复。",
    id: "Folder di dalamnya ikut terhapus beserta seluruh isinya dan tidak dapat dipulihkan.",
  },
  /** 批量删除提示：含数字人级联（约 n 个衍生后代） */
  resPageBatchDeleteHintDigitalN: {
    en: "Characters in the selection will also delete their derived descendants (about {n}). Deletion fails if the character or any derivative/copy is referenced by a task.",
    zh: "其中数字人将同时删除其衍生后代（约 {n} 个）。若自身或任一衍生/副本已被任务引用，则无法删除。",
    id: "Karakter di dalamnya akan ikut menghapus turunannya (sekitar {n}). Penghapusan gagal jika karakter atau turunan/salinannya sedang dirujuk oleh tugas.",
  },
  /** 批量删除提示：含数字人（无衍生） */
  resPageBatchDeleteHintDigital: {
    en: "Deletion fails if a character or its derivatives is referenced by a task. This cannot be undone.",
    zh: "若数字人或其衍生形象已被任务引用，则无法删除。删除后不可恢复。",
    id: "Penghapusan gagal jika karakter atau turunannya sedang dirujuk oleh tugas. Tidak dapat dipulihkan setelah dihapus.",
  },
  /** 打开拆解报告：暂无对应报告 */
  resPageNoBreakdownReport: { en: "No breakdown report available yet", zh: "暂无对应拆解报告", id: "Belum ada laporan analisis" },
  /** 数字人衍生节点兜底名称 */
  resPageDerivedFallbackName: { en: "Derived character", zh: "衍生形象", id: "Karakter turunan" },
  /** 数字人关系面板基底角色兜底 */
  resPageBaseRole: { en: "Base character", zh: "基底形象", id: "Karakter dasar" },
  /** 数字人关系面板基底说明（{name}：基底名称） */
  resPageBaseDetail: {
    en: "Base character of “{name}”. Generate various style avatars via character variation.",
    zh: "{name}的基底形象，可通过形象衍生生成多种造型分身。",
    id: "Karakter dasar dari “{name}”, dapat menghasilkan berbagai avatar gaya melalui variasi karakter.",
  },
  /** 数字人关系面板衍生节点说明（{parent}：基底名称，{role}：衍生描述） */
  resPageDerivedDetail: {
    en: "Generated from “{parent}” via character variation. Derivation: {role}.",
    zh: "由「{parent}」通过形象衍生生成，衍生描述：{role}。",
    id: "Dibuat dari “{parent}” melalui variasi karakter. Deskripsi turunan: {role}.",
  },
  /** 下载：暂无可下载文件 */
  resPageNoDownloadFile: { en: "No file available to download", zh: "暂无可下载文件", id: "Tidak ada file yang dapat diunduh" },
  /** 保存失败提示 */
  resPageSaveFailed: { en: "Save failed", zh: "保存失败", id: "Gagal menyimpan" },
  /** 移动端筛选：排序方式标签 */
  resPageSortLabel: { en: "Sort by", zh: "排序方式", id: "Urutkan" },
  /** 排序选项：名称正序 */
  resPageSortNameAsc: { en: "Name A-Z", zh: "名称正序", id: "Nama A-Z" },
  /** 排序选项：名称倒序 */
  resPageSortNameDesc: { en: "Name Z-A", zh: "名称倒序", id: "Nama Z-A" },
  /** 排序选项：时间正序（最早在前） */
  resPageSortTimeAsc: { en: "Oldest first", zh: "时间正序", id: "Terlama dulu" },
  /** 排序选项：时间倒序（最新在前） */
  resPageSortTimeDesc: { en: "Newest first", zh: "时间倒序", id: "Terbaru dulu" },
  /** 排序选项：大小从小到大 */
  resPageSortSizeAsc: { en: "Size: small to large", zh: "大小从小到大", id: "Ukuran kecil ke besar" },
  /** 排序选项：大小从大到小 */
  resPageSortSizeDesc: { en: "Size: large to small", zh: "大小从大到小", id: "Ukuran besar ke kecil" },
  /** 数字人占位卡兜底名称（{n}：数字人 ID） */
  resPageDigitalFallbackName: { en: "Character-{n}", zh: "数字人-{n}", id: "Karakter-{n}" },
  /** 未选择目录时的写入拦截提示 */
  resPageSelectFolderFirst: { en: "Select a folder first", zh: "请先选择目录", id: "Pilih folder terlebih dahulu" },
  /** 新建/重命名兜底文件夹名 */
  resPageUntitledFolder: { en: "Untitled folder", zh: "未命名文件夹", id: "Folder tanpa nama" },
  /** 资产库根目录不可改名 */
  resPageRootRenameForbidden: {
    en: "Asset library root folders cannot be renamed",
    zh: "资产库根目录不可改名",
    id: "Folder root pustaka aset tidak dapat diganti nama",
  },
  /** 资产库根目录不可删除 */
  resPageRootDeleteForbidden: {
    en: "Asset library root folders cannot be deleted",
    zh: "资产库根目录不可删除",
    id: "Folder root pustaka aset tidak dapat dihapus",
  },
  /** 资产库根目录不可移动 */
  resPageRootMoveForbidden: {
    en: "Asset library root folders cannot be moved",
    zh: "资产库根目录不可移动",
    id: "Folder root pustaka aset tidak dapat dipindahkan",
  },
  /** 资产库根目录不可复制 */
  resPageRootCopyForbidden: {
    en: "Asset library root folders cannot be copied",
    zh: "资产库根目录不可复制",
    id: "Folder root pustaka aset tidak dapat disalin",
  },
  /** 所选内容无法移动 */
  resPageMoveUnsupported: {
    en: "The selected items cannot be moved",
    zh: "所选内容无法移动",
    id: "Item yang dipilih tidak dapat dipindahkan",
  },
  /** 跨分类移动拦截 */
  resPageMoveCrossCategory: { en: "Cannot move across categories", zh: "不能跨分类移动", id: "Tidak dapat memindahkan lintas kategori" },
  /** 移动成功提示 */
  resPageMoveOk: { en: "Moved", zh: "移动成功", id: "Berhasil dipindahkan" },
  /** 移动弹窗兜底目标名 */
  resPageTargetFolder: { en: "Target folder", zh: "目标文件夹", id: "Folder tujuan" },
  /** 移动成功提示（{name}：目标文件夹名） */
  resPageMovedTo: { en: "Moved to “{name}”", zh: "已移动到「{name}」", id: "Dipindahkan ke “{name}”" },
  /** 批量复制成功提示（{n}：数量） */
  resPageCopiedN: { en: "Copied {n} items", zh: "已复制 {n} 项", id: "Menyalin {n} item" },
  /** 数字人或衍生形象被任务引用，禁止删除 */
  resPageDigitalReferenced: {
    en: "This character or its derivatives is referenced and cannot be deleted",
    zh: "该数字人或其衍生形象已被引用，无法删除",
    id: "Karakter ini atau turunannya sedang dirujuk dan tidak dapat dihapus",
  },
  /** 无法粘贴到当前目录 */
  resPagePasteTargetInvalid: {
    en: "Cannot paste to the current folder",
    zh: "无法粘贴到当前目录",
    id: "Tidak dapat menempel ke folder saat ini",
  },
  /** 跨分类粘贴拦截 */
  resPagePasteCrossCategory: { en: "Cannot paste across categories", zh: "不能跨分类粘贴", id: "Tidak dapat menempel lintas kategori" },
  /** 粘贴到自身或子文件夹拦截 */
  resPagePasteNested: {
    en: "Cannot paste into itself or its subfolders",
    zh: "不能粘贴到自身或其子文件夹",
    id: "Tidak dapat menempel ke foldernya sendiri atau subfoldernya",
  },
  /** 粘贴成功提示 */
  resPagePasted: { en: "Pasted", zh: "已粘贴", id: "Berhasil ditempel" },
  /** 该数字人无法删除 */
  resPageDigitalUndeletable: { en: "This character cannot be deleted", zh: "该数字人无法删除", id: "Karakter ini tidak dapat dihapus" },
  /** 该素材无法删除 */
  resPageAssetUndeletable: { en: "This asset cannot be deleted", zh: "该素材无法删除", id: "Materi ini tidak dapat dihapus" },
  /** 保存成功提示 */
  resPageSaved: { en: "Saved", zh: "已保存", id: "Tersimpan" },
  /** 数字人保存失败：无法解析 ID */
  resPageDigitalSaveUnsupported: {
    en: "Cannot save this character",
    zh: "无法保存数字人",
    id: "Tidak dapat menyimpan karakter ini",
  },
  /** 素材保存失败：无法解析素材库 ID */
  resPageMaterialSaveUnsupported: {
    en: "Cannot save to the material library",
    zh: "无法保存到素材库",
    id: "Tidak dapat menyimpan ke pustaka materi",
  },
  /** AI 生图占位卡兜底标题 */
  resPageAiImageFallback: { en: "AI image", zh: "AI 图片", id: "Gambar AI" },
  /** 资产库目录树加载失败 */
  resPageTreeLoadFailed: {
    en: "Failed to load the asset library tree",
    zh: "加载资产库目录失败",
    id: "Gagal memuat direktori pustaka aset",
  },
  /** 访客态预览角标兜底：拉片结果 */
  resGuestShotResult: { en: "Shot analysis result", zh: "拉片结果", id: "Hasil analisis shot" },
  /** 访客态预览特性行：口播/旁白自动提取 */
  resGuestFeatureVoiceover: {
    en: "Voiceover/narration script · Auto-extracted",
    zh: "口播/旁白文案 · 自动提取",
    id: "Naskah sulih suara/narasi · Ekstraksi otomatis",
  },
  /** 访客态预览特性行：分镜时序精准还原 */
  resGuestFeatureStoryboard: {
    en: "Storyboard timing · Precisely restored",
    zh: "分镜时序 · 精准还原",
    id: "Urutan storyboard · Dipulihkan akurat",
  },
  /** 访客态预览特性行：镜头与场景智能标注 */
  resGuestFeatureScenes: {
    en: "Shots & scenes · Smart tagging",
    zh: "镜头与场景 · 智能标注",
    id: "Shot & adegan · Penandaan cerdas",
  },
  /** 访客态预览角标兜底：参考视频 */
  resGuestRefVideo: { en: "Reference video", zh: "参考视频", id: "Video referensi" },
  /** 访客态预览角标兜底：复刻视频 */
  resGuestReplicaVideo: { en: "Replica video", zh: "复刻视频", id: "Video replika" },
  /** 访客态预览角标兜底：功能展示 */
  resGuestFeatureShow: { en: "Feature showcase", zh: "功能展示", id: "Fitur unggulan" },
} as const;
